import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import ActivityLog from '../components/ActivityLog';

/**
 * Founders only (route gated on REACT_APP_ADMIN_EMAILS, API on requires_admin):
 * the audit log across every firm, for support and for answering a
 * customer's "who did this?" (enterprise batch 9).
 */
const AdminActivity: React.FC = () => (
  <Box sx={{ maxWidth: 1300, mx: 'auto', p: 2 }}>
    <Typography variant="h5" fontWeight={700} sx={{ mb: 0.5 }}>
      Activity, all firms
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      Every firm's audit log in one place. Search by part of a firm name or an email address.
      Firm admins see only their own firm's rows on their Team page.
    </Typography>
    <Paper variant="outlined" sx={{ p: 2 }}>
      <ActivityLog scope="admin" />
    </Paper>
  </Box>
);

export default AdminActivity;
